module.exports = __webpack_public_path__ + "static/media/3.52e21b99.png";